"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// NOTE: styles NOT in the Chakra's base styles do not need to explicitly export baseStyles
// TODO: move this comment to the readme

var styles = {
  colSpan: 12
};
var _default = exports["default"] = styles;